import { render } from "./ModalForm.vue?vue&type=template&id=0b8848db&scoped=true"
import script from "./ModalForm.vue?vue&type=script&lang=js"
export * from "./ModalForm.vue?vue&type=script&lang=js"

import "./ModalForm.vue?vue&type=style&index=0&id=0b8848db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8848db"]])

export default __exports__